import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from '@hooks';
import { StyledTimeframePicker } from './styles';

const ScheduledTimeField = ({ isView }) => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext();

    return (
        <Controller
            control={control}
            name="scheduledTime"
            render={({ field, fieldState: { error } }) => (
                <StyledTimeframePicker
                    value={[field.value]}
                    range={false}
                    label={t('common.scheduledTime')}
                    showTimeSelect
                    required
                    disabled={isView}
                    dateFormat="d MMM yyyy, HH:mm"
                    onBlurTimeSelect={field.onBlur}
                    onChangeTimeframe={value => {
                        setValue('scheduledTime', value, {
                            shouldValidate: true,
                            shouldDirty: true,
                        });
                    }}
                    minDate={new Date()}
                    maxDate={null}
                    error={error}
                />
            )}
        />
    );
};

export default ScheduledTimeField;
